import { render, staticRenderFns } from "./BCY.vue?vue&type=template&id=16f19636"
import script from "./BCY.vue?vue&type=script&lang=js"
export * from "./BCY.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports